import { useContext, useEffect, useState } from "react";
import { useKeycloak } from "@react-keycloak/web";
import { Grid } from "@mui/material";
import StrapiApi from "../../../strapi/StrapiApi";
import StrapiData from "../../../strapi/models/StrapiData";
import ArticleAdmissionsCard from "./ArticleAdmissionsCard";
import ContactType from "../../../strapi/models/Contact";
import SalesContactType from "../../../strapi/models/SalesContact";
import ContactCard from "../../components/card/ContactCard";
import CustomerContext from "../../contexts/CustomerContext";
import SalesContactCard from "../../components/card/SalesContactCard";
import { gridContainerStyles } from "../contact/contactStyles";

const ArticleAdmissions = () => {
  const { keycloak } = useKeycloak();
  const { customerNumber } = useContext(CustomerContext);
  const strapiApi = new StrapiApi(keycloak.token || "", customerNumber);
  const [contacts, setContacts] = useState<StrapiData<ContactType>[]>();
  const [salesContacts, setSalesContacts] =
    useState<StrapiData<SalesContactType>[]>();

  useEffect(() => {
    let isApiSubscribed = true;

    if (isApiSubscribed && customerNumber) {
      strapiApi.getContacts().then((res) => {
        setContacts(res.data.data);
      });
      strapiApi.getSalesContacts().then((res) => {
        setSalesContacts(res.data.data);
      });
    }

    return () => {
      isApiSubscribed = false;
    };
  }, [customerNumber]);

  return (
    <Grid container spacing={3} sx={gridContainerStyles}>
      <Grid item xs={12} md={6} lg={4}>
        <ArticleAdmissionsCard />
      </Grid>
      {salesContacts && salesContacts[0] && (
        <Grid item xs={12} md={6} lg={3}>
          <SalesContactCard
            contactInfo={salesContacts[0].attributes}
            baseUrl={strapiApi.axiosRequestConfig.baseURL || ""}
            sx={{
              minHeight: {
                xs: "0px",
                lg: "487px",
              },
            }}
          />
        </Grid>
      )}
      {contacts && contacts[0] && (
        <Grid item xs={12} md={6} lg={4}>
          <ContactCard contactInfo={contacts[0].attributes} />
        </Grid>
      )}
    </Grid>
  );
};

export default ArticleAdmissions;
